// src/services/kpiService.js

import {
  mockKPIsGlobales,
  mockVisitantesRealesVsProyectados,
  mockVisitantesBreakEven,
  mockDistribucionIngresos,
  mockInvertidoVsEbitda,
  mockApalancamientoArea,
  mockDeudaPorArea,
  mockActivosPorArea,
  mockRetrasosImpagos,
  mockPrincipalesAcreedores,
  mockGruposCostes,
  mockDistribucionCostes,
  mockSubgruposCostes,
  mockMerchandising,
  mockMerchandisingBarras,
  mockGestionInternaExterna,
  mockSubgruposMerchandising,
  mockFoodBeverage,
  mockFunnelVentas,
  mockMetricasCRM,
  mockTicketing,
} from '../utils/mockData';

// Siempre usar mocks
const USE_MOCK = true;

/**
 * Simulación de delay de red
 */
const simulateNetworkDelay = () =>
  new Promise(resolve => setTimeout(resolve, 250 + Math.random() * 250));

/**
 * Transforma array de KPIs a objeto con camelCase
 */
const transformKPIsToObject = (kpisArray) => {
  if (!Array.isArray(kpisArray)) {
    console.error('❌ kpisArray no es un array:', kpisArray);
    return {};
  }

  const kpisObject = {};

  kpisArray.forEach(kpi => {
    const kpiName = kpi.kpi?.replace(/_([a-z])/g, g => g[1].toUpperCase());
    kpisObject[kpiName] = kpi;
  });

  return kpisObject;
};

const kpiService = {
  // ================= KPIs GLOBALES =================
  getKPIsGlobales: async () => {
    await simulateNetworkDelay();
    const data = mockKPIsGlobales.data;

    return {
      success: true,
      data: {
        ...data,
        kpis: transformKPIsToObject(data.global),
      },
    };
  },

  getKPIEspecifico: async (kpiName) => {
    const res = await kpiService.getKPIsGlobales();
    const kpi = res.data?.global?.find(k => k.kpi === kpiName);
    return {
      success: !!kpi,
      data: kpi || null,
    };
  },

  // ================= VISITANTES ====================
  getVisitantesRealesVsProyectados: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockVisitantesRealesVsProyectados };
  },
  getVisitantesBreakEven: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockVisitantesBreakEven };
  },

  // ================= FINANZAS - INGRESOS ===========
  getDistribucionIngresos: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockDistribucionIngresos };
  },
  getInvertidoVsEbitda: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockInvertidoVsEbitda };
  },

  // ============ FINANZAS - APALANCAMIENTO ==========
  getApalancamientoPorArea: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockApalancamientoArea };
  },
  getDeudaPorArea: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockDeudaPorArea };
  },
  getActivosPorArea: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockActivosPorArea };
  },

  // ===== FINANZAS - RETRASOS E IMPAGOS =============
  getRetrasosImpagos: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockRetrasosImpagos };
  },
  getPrincipalesAcreedores: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockPrincipalesAcreedores };
  },

  // =========== OPERACIONES - COSTES ================
  getGruposCostes: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockGruposCostes };
  },
  getDistribucionCostes: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockDistribucionCostes };
  },
  getSubgruposCostes: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockSubgruposCostes };
  },

  // ========= OPERACIONES - MERCHANDISING ===========
  getMerchandising: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockMerchandising };
  },
  getMerchandisingBarras: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockMerchandisingBarras };
  },
  getGestionInternaExterna: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockGestionInternaExterna };
  },
  getSubgruposMerchandising: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockSubgruposMerchandising };
  },

  // ====== OPERACIONES - FOOD & BEVERAGE ============
  getFoodBeverage: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockFoodBeverage };
  },

  // ================ CRM Y VENTAS ===================
  getFunnelVentas: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockFunnelVentas };
  },
  getMetricasCRM: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockMetricasCRM };
  },

  // ================= TICKETING =====================
  getTicketing: async () => {
    await simulateNetworkDelay();
    return { success: true, data: mockTicketing };
  },
};

export default kpiService;